import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchDefaultGitBranch } from '@/services/git/api';
import type { GitBranch } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useDefaultGitBranch(): UseQueryResult<GitBranch | null, Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['defaultGitBranch', orgId],
    queryFn: () => fetchDefaultGitBranch(orgId!),
    enabled: !!token && !!orgId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
